// Real assets from Telleixako Benta restaurant
export const LOGO =
  "https://customer-assets.emergentagent.com/job_telleixako-dining/artifacts/x0z8lyrf_IMG_6859.jpeg";

// Real, clean photos provided by the restaurant
export const PHOTOS = {
  // B&W — tirando caña en la barra (hero)
  heroBW:
    "https://customer-assets.emergentagent.com/job_telleixako-dining/artifacts/dtv160ux_Captura%202026-06-10%20a%20las%2017.13.11.png",
  // Grifo de cerveza Cruzcampo con rosa blanca (barra)
  barTap:
    "https://customer-assets.emergentagent.com/job_telleixako-dining/artifacts/ggfv1xx8_IMG_3775.jpeg",
  // Arroz del menú del día servido por camarera
  arroz:
    "https://customer-assets.emergentagent.com/job_telleixako-dining/artifacts/lp1rlv1j_IMG_3807.jpeg",
  // Tacos mexicanos (raciones)
  tacos:
    "https://customer-assets.emergentagent.com/job_telleixako-dining/artifacts/9uz6r86x_IMG_7599.jpeg",
  // Pintxo de croissant con jamón y aro rebozado + zumo
  pintxoCroissant:
    "https://customer-assets.emergentagent.com/job_telleixako-dining/artifacts/ej4et6oq_IMG_4263.jpeg",
  // Ensalada de queso de cabra con nueces
  ensalada:
    "https://customer-assets.emergentagent.com/job_telleixako-dining/artifacts/nlt8fetl_IMG_5709.jpeg",
  // Pintxo de champiñones con jamón
  pintxoChampi:
    "https://customer-assets.emergentagent.com/job_telleixako-dining/artifacts/489jwsym_IMG_2257.jpeg",
  // Pintxo de croqueta crujiente con jamón
  pintxoCroqueta:
    "https://customer-assets.emergentagent.com/job_telleixako-dining/artifacts/1riayzdf_IMG_5155.jpeg",
  // Cartel iluminado del local
  signage:
    "https://customer-assets.emergentagent.com/job_telleixako-dining/artifacts/3e8jgpde_IMG_5685.jpeg",
  // Croissants con logo de fondo desenfocado (Sobre nosotros)
  croissantsLogo:
    "https://customer-assets.emergentagent.com/job_telleixako-dining/artifacts/3tutwkj2_IMG_6862.jpeg",
  // Gildas en pizarra (pintxo clásico)
  gildas:
    "https://customer-assets.emergentagent.com/job_telleixako-dining/artifacts/pnzphavl_IMG_6861.jpeg",
  // Terraza panorámica frontal con cartel TELLEIXAKO BENTA
  terraceFront:
    "https://customer-assets.emergentagent.com/job_telleixako-dining/artifacts/4ov53i68_IMG_6222.jpeg",
  // Terraza esquina low-angle nocturna
  terraceCorner:
    "https://customer-assets.emergentagent.com/job_telleixako-dining/artifacts/z8ykq8qj_IMG_6223.jpeg",
};
